import { useEffect, useRef, useState, useCallback } from "react";
// import styles from "../productList.module.scss";
import styles from "./addProductWizard.module.scss"
import AvailableIcon from "../../../assets/images/available.svg";
import NotAvailableIcon from "../../../assets/images/notFound.svg";
import { productApi } from "../../../api/productApi";
import TablePagination from "../../../components/tablePagination/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedProduct, setSelectedProduct } from "./AddProductWizardSlice";
import { sdStates } from "../../sharedData/sharedDataSlice";

const CopyFromExisting = () => {
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(true);
  const searchTimeoutId = useRef(null);
  const itemsPerPage = 5;
  const [currPage, setCurrPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const selectedProduct = useSelector(selectSelectedProduct);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSelectedProduct(null));
    const fetchProducts = async () => {
      setLoading(true);
      const payload = {
        and: [{
          SdAvailable: {
            eq: true
          }
        }],
        or: [{
          State: {
            eq: sdStates.staging
          }
        }, {
          State: {
            eq: sdStates.production
          }
        }]
      };
      const res = await searchProducts(payload)
      setProductList(res.items);
      setLoading(false);
    }
    fetchProducts()
  }, [])

    const handleSearch = useCallback((event) => {
    if (searchTimeoutId.current) {
      clearTimeout(searchTimeoutId.current);
    }
    setLoading(true);
    searchTimeoutId.current = setTimeout(async () => {
      const searchText = event.target.value.trim();
      const payload =
        searchText === ""
          ? {
            and: [{
              SdAvailable: {
                eq: true
              }
            }],
            or: [{
              State: {
                eq: sdStates.staging
              }
            }, {
              State: {
                eq: sdStates.production
              }
            }]
          }
          : {
            and: [
              {
                SdAvailable: {
                  eq: true
                }
              },
              {
                or: [
                  {
                    State: {
                      eq: sdStates.staging
                    }
                  },
                  {
                    State: {
                      eq: sdStates.production
                    }
                  }
                ]
              },
              {
                or: [
                  {
                    ModelNumber: {
                      // eq: `${searchText}`
                      wildcard: `*${searchText}*`,
                    }
                  },
                  {
                    Family: {
                      // eq: `${searchText}`
                      wildcard: `*${searchText}*`,
                    }
                  }
                ]
              }
            ]
          };
      const res = await searchProducts(payload)
      setProductList(res.items);
      setLoading(false);
    }, 500);
  // };
  }, [dispatch]);

  const searchProducts = async (payload) => {
    const updatedPayload = {
      filter: payload,
      initLoad: true,
      // limit: currState.limit,
    };
    const res = await productApi.searchProducts(updatedPayload);
    return res;
  }

  const onPageChange = async ({ gotoPage }) => {
    // await dispatch(updatePage({ gotoPage }));
    setCurrPage(gotoPage);
  };

  const handleModelNumberClick = (product) => {
    console.log(product)
  }

  const handleSelection = (product) => {
    // setSelectedProduct(product)
    dispatch(setSelectedProduct(product));
    console.log(product);
  }

  return (
    <div className={styles.copyFromExisting}>
      <form className={styles.search}>
        <input
          onChange={handleSearch}
          className={styles.search}
          type="search"
          placeholder="Search model, family, sub family and category"
        />
      </form>

      {/**************************************** Table **********************************************************/}

      <div className={styles.table}>
        <div className={styles.tableContainer}>
          <div style={{ width: "100%" }}>
            <div className={styles.header}>
              <div style={{ maxWidth: "0.8rem" }}>
                Select
              </div>
              <div>
                <span>Model Number</span>
              </div>
              <div>
                <span>Product Family</span>
              </div>
              <div>
                <span>Product sub category</span>
              </div>
              <div style={{ maxWidth: "0.8rem" }}>Shared Data</div>
              <div>
                <span>State</span>
              </div>
            </div>
            {loading ? (
              <div className={styles.noResultFound} style={{ textAlign: "center", padding: "2rem 0", width: "100%" }}>
                Loading...
              </div>
            ) : productList.length === 0 ? (
              <div className={styles.noResultFound} style={{ textAlign: "center", padding: "2rem 0", width: "100%" }}>
                No result found!
              </div>
            ) : (
           productList.map((item) => {
              return (
                <div key={JSON.stringify(item)} className={styles.contentRow}>
                  <div className={styles.td} style={{ maxWidth: "0.8rem" }}><input type="radio" checked={selectedProduct?.id  === item.id} onChange={() => handleSelection(item)} /></div>
                  <div className={styles.td}><span>{item.ModelNumber}</span></div>
                  <div className={styles.td}>{item.Family}</div>
                  <div className={styles.td}>{item.SubCategory}</div>
                  <div className={styles.td} style={{ maxWidth: "0.8rem" }}>
                    <div className={styles.availabilityIcon}>
                      <img
                        src={
                          item.SdAvailable ? AvailableIcon : NotAvailableIcon
                        }
                        alt="Actions Icon"
                      />
                    </div>
                  </div>
                  <div className={styles.td}>
                    <div className={styles.state}>{item.State || "-"}</div>
                  </div>
                </div>
              );
             })
           )}
          </div>
        </div>
        {/* <TablePagination
            total={totalResults}
            currentPage={currPage}
            onPageChange={onPageChange}
            itemsPerPage={itemsPerPage}
            items={productList}
            // onItemsPerPageChange={onItemsPerPageChange}
          /> */}
      </div>

    </div>
  )
}

export default CopyFromExisting;